import { render, staticRenderFns } from "./PhotoConfirmation.vue?vue&type=template&id=1506260f&lang=pug&"
import script from "./PhotoConfirmation.vue?vue&type=script&lang=js&"
export * from "./PhotoConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports